export default __webpack_public_path__ + "static/media/Weather.0ab23b74.jpg";